//#region src/properties/roomPicker/roomTypes.ts
var e = 3, t = (e, t) => t && e != null && e > 0 && e <= 3, n = 3, r = {
	freeCancellation: !1,
	sleeps: !1
}, i = (e) => e.map((e) => ({
	id: e.id,
	name: e.name,
	unitType: e.unit_type,
	guests: e.guests,
	bedrooms: e.bedrooms,
	beds: e.beds,
	bathrooms: e.bathrooms,
	pooled: e.pooled,
	roomsLeft: e.rooms_left,
	images: e.images,
	rates: e.listings.map((e) => ({
		id: e.id,
		title: e.title,
		price: e.price,
		cancellation: e.cancellation,
		instantBooking: e.instant_booking
	}))
})), a = (e) => {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = {
			id: n.id,
			title: n.title,
			price: n.price,
			instantBooking: n.instant_booking
		}, r = t.get(n.unit.id);
		if (r) {
			r.rates.push(e);
			continue;
		}
		t.set(n.unit.id, {
			id: n.unit.id,
			name: n.unit.name,
			unitType: n.unit.unit_type,
			guests: n.unit.guests,
			bedrooms: n.unit.bedrooms,
			beds: n.unit.beds,
			pooled: n.pooled,
			roomsLeft: n.rooms_left,
			images: n.cover_image_url ? [n.cover_image_url] : [],
			rates: [e]
		});
	}
	return [...t.values()];
}, o = (e) => e.roomsLeft === 0, s = (e) => t(e.roomsLeft, e.pooled), c = (e, t, n) => e.filter((e) => !t.sleeps || e.guests >= 3).map((e) => t.freeCancellation ? {
	...e,
	rates: e.rates.filter(n)
} : e).filter((e) => e.rates.length > 0), l = (e, t) => {
	if (t) for (let n of e) {
		let e = n.rates.find((e) => e.id === t);
		if (e) return {
			roomType: n,
			rate: e
		};
	}
}, u = (e, t) => {
	let n = l(e, t);
	return n && !o(n.roomType) ? n : void 0;
}, d = (e) => {
	let t = e.filter((e) => !o(e)).flatMap((e) => e.rates).map(({ price: e }) => ({
		value: e.stay_nights ? e.value / e.stay_nights : e.value,
		currency: e.currency
	})), [n] = t;
	if (n) return t.filter((e) => e.currency === n.currency).reduce((e, t) => t.value < e.value ? t : e);
};
//#endregion
export { e as LOW_STOCK_THRESHOLD, r as NO_ROOM_FILTERS, n as SLEEPS_FILTER_GUESTS, d as cheapestNightly, c as filterRoomTypes, l as findRate, u as findSelectableRate, t as isLowRoomsLeft, s as isLowStock, o as isSoldOut, i as roomTypesFromProperty, a as roomTypesFromSiblings };
